/* ============================================================
   main.js  -  YE FILE KYA HAI (Roman Urdu / aasan zubaan)
   ------------------------------------------------------------
   Homepage ki saari "harkat" (interactivity) yahan hai. Agar
   JavaScript band ho to bhi page theek chalta hai - links khulte
   hain, form submit hota hai, content parha ja sakta hai. Ye
   file sirf upar se experience behtar banati hai.

   Ye kya kya karti hai:
     - Swiper sliders chalati hai: hero (auto slide), products,
       UGC (mariab.pk jaisa)
     - Search overlay kholna / band karna
     - Mobile nav drawer (side menu) kholna / band karna
     - Cart drawer: "Add to Bag" pe item add, qty +/- , remove,
       subtotal ka hisaab, "free shipping" progress bar, aur
       WhatsApp pe order ka ready message banana
     - Wishlist (dil) button toggle
     - "Shop By Collection" tabs switch karna
     - Toast (choti notification) dikhana
     - Newsletter form ka demo submit
     - Esc dabao to sab overlay band
     - Footer mein current saal (year) likhna

   Settings index.html ke window.GHONCHE_CONFIG se aati hain
   (WhatsApp number, currency PKR, free shipping = 10000).
   Abhi cart sirf demo hai - baad mein Shopify se jurega.
   ============================================================ */
/* Ghonché storefront - progressive enhancement only.
   With JS off: links navigate, forms submit, all content readable. */
(function () {
  "use strict";

  var CFG = window.GHONCHE_CONFIG || {};
  var currency = CFG.currency || "Rs.";
  var threshold = typeof CFG.freeShippingThreshold === "number" ? CFG.freeShippingThreshold : null;

  /* ---------- Shared page-scroll lock (every overlay/drawer/modal) ----------
     Reference-counted: nav drawer, search, cart drawer, quick-view and
     the reel modal can be open independently or nested, so a naive
     lock(true)/lock(false) pair per overlay would let one overlay's
     close call re-enable scroll while another is still open. Also
     pauses Lenis (see the Lenis block below) - body/html
     overflow:hidden alone doesn't stop it, since Lenis drives scroll
     with its own wheel handling rather than the browser's native
     overflow clipping. */
  var overlayLockCount = 0;
  function lockPageScroll(lock) {
    overlayLockCount += lock ? 1 : -1;
    if (overlayLockCount < 0) overlayLockCount = 0;
    var shouldLock = overlayLockCount > 0;
    document.documentElement.style.overflow = shouldLock ? "hidden" : "";
    document.body.style.overflow = shouldLock ? "hidden" : "";
    if (window.__ghoncheLenisSetPaused) window.__ghoncheLenisSetPaused(shouldLock);
  }
  window.__ghoncheLockPageScroll = lockPageScroll;

  /* Real Shopify money formatting (was a hand-rolled "Rs." + n
     concatenation against the static build's fake currency string —
     window.GHONCHE_MONEY_FORMAT is emitted by layout/theme.liquid from
     the real shop.money_format). */
  function fmt(n) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(n, window.GHONCHE_MONEY_FORMAT);
    }
    return currency + " " + Number(n).toLocaleString("en-PK");
  }

  /* Responsive image loading for Shopify CDN images — downloads only required pixels */
  function getCdnUrl(url, width) {
    if (!url || typeof url !== "string" || url.indexOf("cdn.shopify.com") === -1) return url;
    var parts = url.split("?");
    var base = parts[0];
    var query = parts[1] || "";
    var q = query ? query + "&width=" + width : "width=" + width;
    return base + "?" + q;
  }

  function getSrcset(url, widths) {
    if (!url || typeof url !== "string" || url.indexOf("cdn.shopify.com") === -1) return "";
    widths = widths || [400, 600, 900];
    var parts = url.split("?");
    var base = parts[0];
    var query = parts[1] || "";
    return widths
      .map(function (w) {
        var q = query ? query + "&width=" + w : "width=" + w;
        return base + "?" + q + " " + w + "w";
      })
      .join(", ");
  }

  /* ---------- Swiper (as in mariab.pk) ---------- */
  if (window.Swiper) {
    /* Bug fix (see chat): carousels sometimes rendered with the last
       card cut off mid-way instead of a clean full/partial peek - not
       a fixed glitch, it came and went. Cause: Swiper measures each
       .swiper-slide's width once at init, but the web font (Montserrat,
       loaded async from Google Fonts) can still swap in AFTER that -
       swapping a card's title/price from the fallback font to
       Montserrat reflows its text width slightly, so a slide's real
       width can differ from what Swiper measured a moment earlier.
       `observer`/`observeParents` make Swiper auto-recalculate when
       its slides' size changes, and the `load` listener below forces
       one extra update once every image has finished loading too -
       between the two, a stale measurement can't stick around. */
    var allSwipers = [];

    var hero = document.querySelector('[data-swiper="hero"]');
    if (hero) {
      allSwipers.push(new Swiper(hero, {
        loop: true,
        speed: 600,
        observer: true,
        observeParents: true,
        autoplay: { delay: 6000, pauseOnMouseEnter: true },
        pagination: { el: hero.querySelector(".swiper-pagination"), clickable: true },
        navigation: {
          nextEl: hero.querySelector(".swiper-button-next"),
          prevEl: hero.querySelector(".swiper-button-prev")
        },
        on: {
          init: function () { updateHeaderColor(this); },
          slideChangeTransitionEnd: function () { updateHeaderColor(this); }
        }
      }));
    }

    /* per-slide header colour (Maria B pattern): each hero slide carries
       data-header-color; the active slide's value becomes --header-fg,
       which .header--transparent reads. */
    function updateHeaderColor(swiper) {
      var active = swiper.slides && swiper.slides[swiper.activeIndex];
      var color = active && active.getAttribute("data-header-color");
      if (color) document.documentElement.style.setProperty("--header-fg", color);
    }

    /* Transparent header only right at the very top; solid the moment the
       page scrolls even a little - NOT tied to the hero's own height, so
       the switch doesn't wait for the whole hero to scroll past (that was
       the old IntersectionObserver-on-.hero behaviour; a tall hero made
       the header stay transparent well past where the hero's own dark
       art ends, so the nav briefly sat over plain white as a separate-
       looking "second header"). Header markup already starts with
       .header--transparent (page always loads at the top) - applyHeaderState()
       runs once immediately so a reload that restores mid-page scroll
       (e.g. back/forward) is correct on the very first frame, no flash.
       No-JS fallback (forced solid) lives in the <noscript> style in
       index.html, since none of this runs without JS. */
    var header = document.querySelector(".header");
    var logoImg = document.querySelector("[data-header-logo]");
    if (header) {
      /* --header-h ek fixed token (tokens.css) hai jo real font ke saath
         thoda mismatch ho sakta hai (font-load ke baad header 1-2px lamba
         ho jaata hai) - isse hero ke negative margin mein gap reh jaata
         hai (announce bar aur hero ke beech thin seam). Isliye actual
         measured height ko hi CSS var mein likh dete hain taake dono
         hamesha match karein. */
      function syncHeaderH(h) {
        h = h || header.getBoundingClientRect().height;
        if (h) {
          /* thoda ceil taake hero 1px overlap kare, gap kabhi na bache
             (rounding se gap dikhna, overlap kabhi nahi dikhta).
             --hero-pull (--header-h nahi) taake header ki apni
             min-height is se na juṛe - warna circular growth loop. */
          document.documentElement.style.setProperty("--hero-pull", Math.ceil(h) + "px");
        }
      }
      syncHeaderH();
      /* ResizeObserver header ka real size hamesha live track karta hai -
         font swap, logo swap, viewport change, kuch bhi ho, --header-h
         turant sync ho jaata hai. Isse woh 1px gap timing-race se bhi
         nahi bachta. */
      if ("ResizeObserver" in window) {
        new ResizeObserver(function () { syncHeaderH(); }).observe(header);
      } else {
        window.addEventListener("resize", function () { syncHeaderH(); });
      }

      /* --announce-h: the header-group wrapper's sticky offset (see
         components.css .shopify-section-group-header-group) needs the
         announcement bar's REAL height so the header lands at exactly
         top:0 once scrolled past it. The promo text can wrap to 2 lines
         on very narrow screens, so this is measured live, same pattern
         as --hero-pull above, not hardcoded. */
      var announceEl = document.querySelector(".announce");
      if (announceEl) {
        function syncAnnounceH() {
          var h = announceEl.getBoundingClientRect().height;
          if (h) document.documentElement.style.setProperty("--announce-h", Math.ceil(h) + "px");
        }
        syncAnnounceH();
        if ("ResizeObserver" in window) {
          new ResizeObserver(function () { syncAnnounceH(); }).observe(announceEl);
        } else {
          window.addEventListener("resize", syncAnnounceH);
        }
      }

      /* Transparent-over-hero behaviour only makes sense on pages that
         actually HAVE a hero for the header to float over (index.html).
         Interior pages (e.g. pages/collection-list.html) load their
         header without .header--transparent in the markup and have no
         .hero - skip the toggle entirely so it stays solid, instead of
         this scroll listener adding the class back on every such page. */
      var hasHero = !!document.querySelector(".hero");

      /* 990-1279px used to be its own "2-row nav" tier that needed the
         header forced solid here (a transparent 2nd row had no
         background of its own, so its text floated unreadable over the
         hero photo). That tier now uses the same compact single-row
         mobile header (hamburger, centered logo, cart-only icons) as
         <990px - no 2nd row, no floating text - so it no longer needs a
         special case and just follows normal scroll-based transparency
         like every other single-row width. */
      var SOLID_AFTER = 10; // px - "even slightly" scrolled counts as solid
      /* Remembers scrollY across a reload so the inline pre-paint script in
         sections/header.liquid (runs before this deferred file even loads)
         can guess the right initial state instead of flashing transparent
         then snapping solid. window.scrollY itself isn't reliable for that
         script's timing - the browser can restore scroll position a frame
         or two AFTER the earliest synchronous script runs, so reading it
         at that point can still see 0. sessionStorage has no such race. */
      try { sessionStorage.setItem("ghoncheScrollY", String(window.scrollY)); } catch (e) {}
      var isSolid = null;
      function applyHeaderState() {
        if (!hasHero) return;
        var shouldBeSolid = window.scrollY > SOLID_AFTER;
        try { sessionStorage.setItem("ghoncheScrollY", String(window.scrollY)); } catch (e) {}
        if (shouldBeSolid === isSolid) return;
        isSolid = shouldBeSolid;
        header.classList.toggle("header--transparent", !isSolid);
        /* Keeps the pre-paint CSS override (html[data-header-solid], see
           components.css) in sync once this deferred script takes over -
           otherwise scrolling back to the top after a scrolled reload
           would try to go transparent again but stay stuck solid, since
           the attribute set before this script ran would never clear. */
        if (isSolid) document.documentElement.setAttribute("data-header-solid", "");
        else document.documentElement.removeAttribute("data-header-solid");
        if (logoImg) {
          logoImg.src = isSolid
            ? logoImg.getAttribute("data-src-dark")
            : logoImg.getAttribute("data-src-light");
        }
      }
      applyHeaderState();

      var scrollTicking = false;
      if (hasHero) {
        window.addEventListener("scroll", function () {
          if (scrollTicking) return;
          scrollTicking = true;
          requestAnimationFrame(function () {
            applyHeaderState();
            scrollTicking = false;
          });
        }, { passive: true });
      }

      /* Mega menu open/close. Also solidifies the header (mega panel is
         white, transparent header clashed with it) - only while header
         is still transparent (isSolid false); post-scroll solid header
         is unaffected.

         .is-mega-open (not raw :hover in CSS) is what actually shows the
         panel, because the nav <li>s sit 26px apart (flex gap): moving
         the mouse from "Ready To Wear" to "Unstitched" crosses that gap
         hovering neither one, so plain :hover closed the first panel and
         only reopened the next after a visible gap. Switching the class
         here - cancel any pending close, open the new one immediately -
         swaps between the two instead. A short close delay (only
         actually applied if nothing re-opens in time) absorbs that gap
         crossing; leaving the nav for good still closes at the same
         speed as before.

         A direct switch between two triggers is a hard cut, not a
         crossfade - .mega-no-anim kills the transition for one frame
         while both classes flip, then a rAF turns it back on so the
         next genuine open/close (nothing was open / nothing reopens)
         still fades normally. */
      var MEGA_CLOSE_DELAY = 150;
      var activeMegaLi = null;
      var megaCloseTimer = null;

      function openMegaPanel(li) {
        clearTimeout(megaCloseTimer);
        var prev = activeMegaLi;
        activeMegaLi = li;

        if (prev && prev !== li) {
          prev.classList.add("mega-no-anim");
          li.classList.add("mega-no-anim");
          prev.classList.remove("is-mega-open");
          li.classList.add("is-mega-open");
          // Force layout so the transition:none actually applies to this
          // swap before the next frame re-enables it - otherwise both
          // class changes could get batched with the re-enable and the
          // browser would still animate them.
          void li.offsetWidth;
          requestAnimationFrame(function () {
            prev.classList.remove("mega-no-anim");
            li.classList.remove("mega-no-anim");
          });
        } else {
          li.classList.add("is-mega-open");
        }

        /* hasHero-gated: on pages without a hero (isSolid never gets
           initialized by applyHeaderState, so it stays its default
           `null` - falsy, same as isSolid===false) this used to read
           as "header is transparent" even on a plain solid-white
           header, swapping the logo to the white variant on mega-close
           below and leaving it invisible against the white header.
           Only hero pages ever actually have a transparent header to
           solidify. */
        if (hasHero && !isSolid) {
          header.classList.add("header--mega-open");
          if (logoImg) logoImg.src = logoImg.getAttribute("data-src-dark");
        }
      }

      function scheduleMegaClose(li) {
        clearTimeout(megaCloseTimer);
        megaCloseTimer = setTimeout(function () {
          if (activeMegaLi !== li) return;
          li.classList.remove("is-mega-open");
          activeMegaLi = null;
          header.classList.remove("header--mega-open");
          if (hasHero && logoImg && !isSolid) logoImg.src = logoImg.getAttribute("data-src-light");
        }, MEGA_CLOSE_DELAY);
      }

      document.querySelectorAll(".has-mega").forEach(function (li) {
        li.addEventListener("mouseenter", function () { openMegaPanel(li); });
        li.addEventListener("mouseleave", function () { scheduleMegaClose(li); });
        li.addEventListener("focusin", function () { openMegaPanel(li); });
        li.addEventListener("focusout", function (e) {
          if (!li.contains(e.relatedTarget)) scheduleMegaClose(li);
        });
      });
    }

    document.querySelectorAll('[data-swiper="products"]').forEach(function (el) {
      /* Prev/Next buttons ab is swiper ke andar nahi, section heading
         row (.section__head-actions) mein "View All" ke sath rehte
         hain - isliye poore <section> mein dhoondhna padta hai, sirf
         `el` (.swiper) ke andar nahi. */
      var scope = el.closest("section") || el;
      allSwipers.push(new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 14,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: scope.querySelector(".swiper-button-next"),
          prevEl: scope.querySelector(".swiper-button-prev")
        }
      }));
    });

    document.querySelectorAll('[data-swiper="ugc"]').forEach(function (el) {
      allSwipers.push(new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 14,
        observer: true,
        observeParents: true
      }));
    });

    /* Reviews (see chat): auto-playing 1-up slider with dots below 900px;
       at 900px+ Swiper's own breakpoint switches to a static 3-up row
       (autoplay/pagination/touch all off) - the same layout this section
       always had on desktop, now just driven by Swiper instead of CSS
       grid so mobile and desktop share one markup. */
    document.querySelectorAll('[data-swiper="reviews"]').forEach(function (el) {
      allSwipers.push(new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay: { delay: 4500, disableOnInteraction: false, pauseOnMouseEnter: true },
        pagination: { el: el.querySelector(".reviews__pagination"), clickable: true },
        observer: true,
        observeParents: true,
        breakpoints: {
          900: {
            slidesPerView: 3,
            spaceBetween: 16,
            loop: false,
            autoplay: false,
            allowTouchMove: false
          }
        }
      }));
    });

    window.addEventListener("load", function () {
      allSwipers.forEach(function (s) { s.update(); });
    });
  }

  /* ---------- Overlay helper ---------- */
  var overlay = document.querySelector("[data-overlay]");
  function showOverlay(on) {
    if (!overlay) return;
    overlay.hidden = !on;
    if (on) overlay.setAttribute("data-open", "");
    else overlay.removeAttribute("data-open");
    lockPageScroll(on);
  }

  /* ---------- Search overlay ---------- */
  var search = document.querySelector("[data-search]");
  function openSearch() {
    if (!search) return;
    search.setAttribute("data-open", "");
    var input = search.querySelector("[data-search-input]");
    if (input) input.focus();
  }
  function closeSearch() {
    if (search) search.removeAttribute("data-open");
  }
  document.querySelectorAll("[data-search-toggle]").forEach(function (b) {
    b.addEventListener("click", openSearch);
  });
  var searchClose = document.querySelector("[data-search-close]");
  if (searchClose) searchClose.addEventListener("click", closeSearch);

  /* ---------- Mobile nav drawer ---------- */
  var nav = document.querySelector("[data-nav-drawer]");
  function openNav() {
    if (!nav) return;
    nav.setAttribute("data-open", "");
    showOverlay(true);
  }
  function closeNav() {
    if (nav) nav.removeAttribute("data-open");
    var cartOpen = window.GhoncheCart && window.GhoncheCart.isDrawerOpen();
    if (!cartOpen) showOverlay(false);
  }
  document.querySelectorAll("[data-nav-toggle]").forEach(function (b) {
    b.addEventListener("click", openNav);
  });
  var navClose = document.querySelector("[data-nav-close]");
  if (navClose) navClose.addEventListener("click", closeNav);

  // Cart drawer/state/rendering all live in js/cart-drawer.js (the one
  // reusable Cart component, loaded before this file) — nothing cart-
  // related belongs here anymore. window.GhoncheCart / window.addToCart /
  // window.openCart / window.closeCart are its public API.
  window.__ghoncheNavOpen = function () { return !!(nav && nav.hasAttribute("data-open")); };
  if (overlay) overlay.addEventListener("click", function () { closeNav(); });

  /* ---------- Wishlist hearts ---------- */
  var WISHLIST_KEY = "ghonche_wishlist";
  function getWishlistHandle(card) {
    if (!card) return "";
    var link = card.querySelector('.card__title a') || card.querySelector('.card__media a') || card.querySelector('a[href*="/products/"]');
    if (!link) return "";
    var href = link.getAttribute("href") || "";
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : "";
  }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]"); } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function syncWishlistHearts() {
    var saved = getWishlist();
    document.querySelectorAll(".card").forEach(function (card) {
      var handle = getWishlistHandle(card);
      if (!handle) return;
      var wish = card.querySelector(".card__wish");
      if (wish) {
        var isSaved = saved.indexOf(handle) !== -1;
        wish.setAttribute("aria-pressed", String(isSaved));
      }
    });
  }
  syncWishlistHearts();

  /* Static build split this into two handlers (main.js skipped
     [data-wish] buttons, category.js handled them separately) because
     its cards were injected client-side after main.js had already run.
     Every card is real, server-rendered Liquid now — no timing gap —
     so one delegated handler covers both card styles. */
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".card__wish");
    if (!b) return;
    var card = b.closest(".card");
    var handle = getWishlistHandle(card);
    var on = b.getAttribute("aria-pressed") === "true";
    if (handle) {
      var list = getWishlist();
      if (on) {
        list = list.filter(function (h) { return h !== handle; });
      } else {
        if (list.indexOf(handle) === -1) list.push(handle);
      }
      saveWishlist(list);
    }
    b.setAttribute("aria-pressed", String(!on));
    toast(!on ? "Saved to wishlist" : "Removed from wishlist");
  });

  /* ---------- Tabs ---------- */
  document.querySelectorAll("[data-tabs]").forEach(function (tabs) {
    var btns = tabs.querySelectorAll('[role="tab"]');
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        btns.forEach(function (b) { b.setAttribute("aria-selected", "false"); });
        btn.setAttribute("aria-selected", "true");
        tabs.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
          p.hidden = p.id !== btn.dataset.tab;
        });
      });
    });
  });

  /* ---------- Toast ---------- */
  var toasts = document.querySelector("[data-toasts]");
  function toast(msg) {
    if (!toasts) return;
    var el = document.createElement("div");
    el.className = "toast";
    el.textContent = msg;
    toasts.appendChild(el);
    setTimeout(function () { el.remove(); }, 3000);
  }

  /* ---------- Newsletter demo (code screen pe dikhao) ---------- */
  document.querySelectorAll("[data-news-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var scope = form.closest("[data-news-scope]") || form.parentElement;
      var code = scope ? scope.querySelector("[data-news-code]") : null;
      if (code) code.hidden = false;
      toast("You're in - code WELCOME10 unlocked.");
      form.reset();
    });
  });

  /* ---------- Esc closes everything ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeCart(); closeNav(); closeSearch();
    }
  });

  /* ---------- Footer year ---------- */
  document.querySelectorAll("[data-year]").forEach(function (y) {
    y.textContent = new Date().getFullYear();
  });

  /* ---------- Mobile menu button visibility ---------- */
  var navToggle = document.querySelector("[data-nav-toggle]");
  function syncNavToggle() {
    if (!navToggle) return;
    navToggle.style.display = window.innerWidth < 1280 ? "" : "none";
    /* The drawer's own CSS doesn't gate itself by viewport width (only
       this trigger button does) - opening it on mobile then resizing
       the window (or rotating a device) past 1280px left it stuck open,
       overlapping the desktop layout, since nothing ever closed it. */
    if (window.innerWidth >= 1280 && nav && nav.hasAttribute("data-open")) closeNav();
  }
  window.addEventListener("resize", syncNavToggle);
  syncNavToggle();

  /* ---------- Bottom bar: highlight the current page ----------
     Only Home and Wishlist are real page links in the bottom bar
     (Search/Bag/Menu just open an overlay on top of whatever page
     you're on) - so only those two can ever be "the current page".
     Matches on pathname so it works the same whether a link is
     written as "/" or "/index.html", with or without ".html". */
  var bottombarLinks = document.querySelectorAll(".bottombar a[href]");
  if (bottombarLinks.length) {
    var herePath = window.location.pathname.replace(/index\.html$/, "").replace(/\/$/, "") || "/";
    bottombarLinks.forEach(function (link) {
      var linkPath = link.getAttribute("href").replace(/index\.html$/, "").replace(/\/$/, "") || "/";
      link.classList.toggle("is-active", linkPath === herePath);
    });
  }

  /* ---------- Desktop-only smooth scroll (Lenis) ----------
     Hand-rolled wheel-hijack (3 tuning rounds: lerp-to-target, phir
     velocity/friction) hamesha kisi na kisi device par jhatka deta
     tha, kyunke trackpad ka apna native momentum-scroll hamari layer
     se takra jaata tha. Lenis ek chhoti, bohat-tested library hai jo
     yehi kaam sahi tareeqe se karti hai (proper per-device/frame-rate
     handling). `lerp: 0.2` = bohat halka effect ("thora sa"), zyada
     halka nahi kiya kyunke phir smooth mehsoos hi nahi hota. Sirf
     Desktop tier (990px+) par chalta hai - mobile/tablet ka native
     scroll bilkul chua tak nahi jaata. */
  if (window.Lenis) {
    (function () {
      var mqDesktop = window.matchMedia("(min-width: 990px)");
      var mqReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
      var lenis = null;
      var rafId = null;
      var pausedByOverlay = false;

      function raf(time) {
        if (!lenis) return;
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      }

      function start() {
        if (lenis) return;
        lenis = new Lenis({ lerp: 0.2 });
        rafId = requestAnimationFrame(raf);
      }

      function stop() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        if (lenis) {
          lenis.destroy();
          lenis = null;
        }
      }

      function sync() {
        if (mqDesktop.matches && !mqReduced.matches && !pausedByOverlay) start();
        else stop();
      }

      /* Called by lockPageScroll() above whenever any overlay/drawer/
         modal opens or closes - Lenis owns wheel scrolling on desktop
         and bypasses the browser's native overflow clipping, so
         body/html overflow:hidden alone never stopped it from
         scrolling the page behind an open cart drawer, search panel,
         nav drawer, quick-view or reel modal. */
      window.__ghoncheLenisSetPaused = function (paused) {
        pausedByOverlay = paused;
        sync();
      };

      mqDesktop.addEventListener("change", sync);
      mqReduced.addEventListener("change", sync);
      sync();
    })();
  }

  // Back-to-top button
  var backToTop = document.getElementById("backToTop");
  if (backToTop) {
    function handleBackToTopScroll() {
      if ((window.scrollY || window.pageYOffset) > 400) {
        backToTop.classList.add("is-visible");
      } else {
        backToTop.classList.remove("is-visible");
      }
    }

    window.addEventListener("scroll", handleBackToTopScroll);
    backToTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    handleBackToTopScroll();
  }
})();
